const firebaseConfig = {
  apiKey: "AIzaSyAaiQ82_I9Lw3xz5UYUKCcTpK87cDDr35I",
  authDomain: "portfolio-sudoarun.firebaseapp.com",
  projectId: "portfolio-sudoarun",
  storageBucket: "portfolio-sudoarun.appspot.com",
  messagingSenderId: "651842937590",
  appId: "1:651842937590:web:7776fab9df0eda3800c2d7",
};
export default firebaseConfig;
